import { render, staticRenderFns } from "./ConsignmentNoteRegistryForm.vue?vue&type=template&id=1a5bebee&scoped=true&"
import script from "./ConsignmentNoteRegistryForm.vue?vue&type=script&lang=js&"
export * from "./ConsignmentNoteRegistryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5bebee",
  null
  
)

export default component.exports